interface IPerson {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    title?: string;
    officePhone?: string;
    cellPhone?: string;
}

class Person implements IPerson {
    public firstName?: string;
    public middleName?: string;
    public lastName?: string;
    public suffix?: string;
    public title?: string;
    public officePhone?: string;
    public cellPhone?: string;

    constructor(p: IPerson = {}) {
        this.firstName = p.firstName;
        this.middleName = p.middleName;
        this.lastName = p.lastName;
        this.suffix = p.suffix;
        this.title = p.title;
        this.officePhone = p.officePhone;
        this.cellPhone = p.cellPhone;
    }
}

export default Person;
export { Person, IPerson};
